import { cn } from "@reactive-resume/utils";

type Props = {
  size?: number;
  className?: string;
};

export const Icon = ({ size = 32, className }: Props) => {
  const src = "/icon/mocvprologo.svg";

  return (
    <img
      src={src}
      width={size}
      height={size}
      alt="Moncvpro"
      className={cn("rounded-sm", className)}
    />
  );
};
